import { useLingui } from '@lingui/react/macro';
import { createFileRoute } from '@tanstack/react-router';
import { getQueryKey } from '@trpc/react-query';

import { TablePage } from '@/components/page/TablePage';
import { useRegistrationsCols } from '@/features/registrations/useRegistrationsCols';
import { useTableQuery } from '@/hooks/useTableQuery';
import { trpc, trpcClient } from '@/services/trpc';

export const Route = createFileRoute('/_baseLayout/registrations/')({
  component: RegistrationsPage,
});

export function RegistrationsPage() {
  const { t } = useLingui();
  const columns = useRegistrationsCols();
  const handleQuery = useTableQuery(trpcClient.registrations.findAll.query);

  return (
    <TablePage
      title={t`Manage`}
      breadcrumbs={[{ label: t`Registrations`, to: '/registrations' }]}
      columns={columns}
      queryKey={getQueryKey(trpc.registrations.findAll)}
      onQueryFn={handleQuery}
    />
  );
}
